module.exports = __webpack_public_path__ + "static/img/logo-RICHMOND.024083c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-RICHMOND.svg
// module id = v1+c
// module chunks = 1